import { render, staticRenderFns } from "./WnlText.vue?vue&type=template&id=6fc1f751&scoped=true&ref=keyText&"
import script from "./WnlText.vue?vue&type=script&lang=js&"
export * from "./WnlText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc1f751",
  null
  
)

export default component.exports